<script setup>
const props = defineProps({
    text: {
        type: [String, Array],
        required: true,
    },
    type: {
        type: String,
        default: "div",
        required: false,
    },
    brClass: {
        type: String,
        default: "",
        required: false,
    },
});
const formatText = useFormat(props.text);

const rootRef = ref(null);
defineExpose({ animate, rootRef });

const { animate: doAnimate } = useSplitText(rootRef);

// 包一層 animate，父層呼叫時能自定參數
function animate(options = {}) {
    doAnimate(options);
}
</script>

<template>
    <component :is="type" ref="rootRef">
        <template v-for="(part, index) in formatText" :key="index">
            <br
                v-if="part.isLineBreak"
                :class="brClass"
                data-static
                aria-hidden="true"
            />
            <span
                v-else-if="part.lang"
                :lang="part.lang"
                class="inline-block overflow-hidden align-bottom"
            >
                {{ part.text }}</span
            >
            <span v-else class="inline-block overflow-hidden align-bottom">
                {{ part.text }}</span
            >
        </template>
    </component>
</template>
